import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, NgModel, Validators } from '@angular/forms';
import { CardInputsAbstractInput } from '../card-inputs.abstract-input';
import { CreditCardValidator } from 'ng-betalabs-creditcard';

@Component({
    'selector': 'card-inputs-expiration',
    'templateUrl': './card-inputs.expiration.component.html',
    'providers': [],
    'styleUrls': []
})
export class CardInputsExpirationComponent extends
    CardInputsAbstractInput implements OnInit, OnDestroy {
    public month;
    public year;
    public expirationYears: Array<number> = [];
    public emptySelectedValueMonth = null;
    public emptySelectedValueYear = null;
    public monthControl: FormControl;
    public yearControl: FormControl;

    ngOnInit() {
        this.expirationYears = this.buildExpirationYears();
        this.form.addControl('expiration_date', this.control = new FormControl(
            '',
            [Validators.required, CreditCardValidator.validateExpDate]
        ));
        this.form.addControl('expiration_month', this.monthControl = new FormControl(
            '',
            [Validators.required]
        ));
        this.form.addControl('expiration_year', this.yearControl = new FormControl(
            '',
            [Validators.required]
        ));
    }
    ngOnDestroy() {
        this.form.removeControl('expiration_date');
    }

    /**
     * Dynamic expiration years.
     * @return Array
     */
    private buildExpirationYears() {
        const firstYear = (new Date()).getFullYear();
        const yearsArr = [];

        for (let i =  firstYear; i < firstYear + 15 ; i++) {
            yearsArr.push(i);
        }

        return yearsArr;
    }

    /**
     * Validate and fill object with expiration month and year values.
     **/
    public fillExpirationDate(modelExpMonth: NgModel, modelExpYear: NgModel) {
        if (this.isInvalidExpirationDate()) {
            modelExpMonth.control.setErrors({expirationDate: true});
            modelExpYear.control.setErrors({expirationDate: true});
            this.control.setErrors({expirationDate: true});
            this.emitChange();
            return;
        }

        if (modelExpMonth.control.hasError('expirationDate')) {
            const errors = modelExpMonth.control.errors;
            delete errors['expirationDate'];
            modelExpMonth.control.setErrors(errors);

            if (this.isObjectEmpty(errors)) {
                modelExpMonth.control.setErrors(null);
            }
        }
        if (modelExpYear.control.hasError('expirationDate')) {
            const errors = modelExpYear.control.errors;
            delete errors['expirationDate'];
            modelExpYear.control.setErrors(errors);

            if (this.isObjectEmpty(errors)) {
                modelExpYear.control.setErrors(null);
            }
        }

        this.monthControl.setValue(this.month);
        this.yearControl.setValue(this.year);
        this.control.setValue(`${this.month}/${this.year}`);
        this.emitChange();
    }
    /**
     * Validate expiration month and year.
     **/
    public isInvalidExpirationDate() {
        const now = new Date();
        const nowMonth = (now.getMonth() + 1);
        const nowYear = now.getFullYear();

        return (
            parseInt(`${+this.year}`, 0) === parseInt(`${+nowYear}`, 0) &&
            parseInt(`${+this.month}`, 0) < parseInt(`${+nowMonth}`, 0)
        );
    }
    /**
     * Checks if an object is empty. It returns true or false.
     *
     * @return bool
     **/
    public isObjectEmpty(object) {
        return Object.getOwnPropertyNames(object).length === 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/card-inputs/expiration/card-inputs.expiration.component.ts